import React from 'react';
export function TermsPage() {
  const handleBack = () => {
    window.location.hash = '';
  };
  return <div className="min-h-screen bg-navy-950 text-slate-100" data-id="element-346">
      <div className="max-w-4xl mx-auto px-6 py-20" data-id="element-347">
        <button onClick={handleBack} className="text-mint-500 hover:text-mint-400 mb-8 inline-flex items-center gap-2 transition-colors" data-id="element-348">
          ← Back to home
        </button>

        <div className="prose prose-invert prose-slate max-w-none" data-id="element-349">
          <h1 className="text-4xl font-bold mb-2" data-id="element-350">Terms of Service</h1>
          <p className="text-slate-400 mb-8" data-id="element-351">Last updated: February 2, 2026</p>

          <div className="space-y-8 text-slate-300 leading-relaxed" data-id="element-352">
            <p data-id="element-353">
              These Terms of Service ("Terms") govern your use of Pulsewave's
              websites and services, including those available at
              https://pulsewaveco.com (the "Services"). By accessing or using
              the Services, you agree to these Terms.
            </p>

            <section data-id="element-354">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-355">
                1. Eligibility
              </h2>
              <p data-id="element-356">
                You must be at least 13 years old (or the minimum legal age in
                your jurisdiction) to use the Services. If you use the Services
                on behalf of an organization, you represent that you have
                authority to bind that organization.
              </p>
            </section>

            <section data-id="element-357">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-358">
                2. Accounts and phone-based authentication
              </h2>
              <ul className="list-disc pl-6 space-y-2" data-id="element-359">
                <li data-id="element-360">
                  Your phone number is the primary identifier for your account
                </li>
                <li data-id="element-361">
                  Access to the Services is authenticated using one-time
                  passcodes sent to your phone
                </li>
                <li data-id="element-362">No passwords are required or stored</li>
                <li data-id="element-363">
                  You are responsible for maintaining control of your phone
                  number and device and for all activity associated with your
                  account
                </li>
                <li data-id="element-364">
                  If you lose access to your phone number or believe your
                  account has been compromised, you must notify us promptly
                </li>
              </ul>
            </section>

            <section data-id="element-365">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-366">
                3. Acceptable use
              </h2>
              <p data-id="element-367">You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-368">
                <li data-id="element-369">Violate any applicable law or regulation</li>
                <li data-id="element-370">Infringe the rights of others</li>
                <li data-id="element-371">Engage in fraud, harassment, or abusive behavior</li>
                <li data-id="element-372">
                  Attempt to gain unauthorized access to the Services or
                  interfere with their operation
                </li>
                <li data-id="element-373">Reverse engineer, scrape, or misuse the Services</li>
              </ul>
              <p className="mt-4" data-id="element-374">
                We may suspend or terminate access if we believe you have
                violated these Terms.
              </p>
            </section>

            <section data-id="element-375">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-376">
                4. Points-only system; no cash value
              </h2>
              <p data-id="element-377">At launch, Pulsewave operates using points only:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-378">
                <li data-id="element-379">
                  Points are provided for promotional and entertainment purposes
                </li>
                <li data-id="element-380">
                  Points do not have cash value, are not money, and are not
                  redeemable for cash unless explicitly stated otherwise in
                  writing
                </li>
                <li data-id="element-381">Points are not transferable except as permitted by us</li>
                <li data-id="element-382">
                  We may modify, limit, suspend, or discontinue points at any
                  time
                </li>
                <li data-id="element-383">
                  The Services are not a real-money wagering or gambling product
                  at launch
                </li>
              </ul>
            </section>

            <section data-id="element-384">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-385">
                5. User content
              </h2>
              <p data-id="element-386">
                You retain ownership of content you submit through the Services
                ("User Content"). By submitting User Content, you grant
                Pulsewave a non-exclusive, worldwide, royalty-free license to
                host, store, reproduce, modify (for formatting), and display
                such content for the purpose of operating and improving the
                Services.
              </p>
              <p className="mt-4" data-id="element-387">
                You represent that you have all necessary rights to submit User
                Content and that it does not violate any law or third-party
                rights.
              </p>
            </section>

            <section data-id="element-388">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-389">
                6. Intellectual property
              </h2>
              <p data-id="element-390">
                All Pulsewave branding, software, designs, and content
                (excluding User Content) are owned by Pulsewave or its licensors
                and are protected by intellectual property laws. You may not use
                them without prior permission except as allowed by law.
              </p>
            </section>

            <section data-id="element-391">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-392">
                7. Third-party services
              </h2>
              <p data-id="element-393">
                The Services may link to or integrate with third-party services.
                Pulsewave is not responsible for third-party services, and your
                use of them is governed by their respective terms and policies.
              </p>
            </section>

            <section data-id="element-394">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-395">
                8. Disclaimers
              </h2>
              <p className="uppercase" data-id="element-396">
                THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE." TO THE
                MAXIMUM EXTENT PERMITTED BY LAW, PULSEWAVE DISCLAIMS ALL
                WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
                NON-INFRINGEMENT.
              </p>
            </section>

            <section data-id="element-397">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-398">
                9. Limitation of liability
              </h2>
              <p className="uppercase" data-id="element-399">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, PULSEWAVE WILL NOT BE
                LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
                PUNITIVE DAMAGES, OR FOR ANY LOSS OF PROFITS, DATA, OR GOODWILL.
                PULSEWAVE'S TOTAL LIABILITY FOR ANY CLAIM WILL NOT EXCEED THE
                GREATER OF $100 OR THE AMOUNT YOU PAID TO PULSEWAVE IN THE 12
                MONTHS PRIOR TO THE CLAIM.
              </p>
            </section>

            <section data-id="element-400">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-401">
                10. Indemnification
              </h2>
              <p data-id="element-402">
                You agree to indemnify and hold harmless Pulsewave from any
                claims, damages, liabilities, and expenses arising out of your
                use of the Services or violation of these Terms.
              </p>
            </section>

            <section data-id="element-403">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-404">
                11. Termination
              </h2>
              <p data-id="element-405">
                You may stop using the Services at any time. We may suspend or
                terminate your access at any time for any reason, including
                violation of these Terms or suspected abuse.
              </p>
            </section>

            <section data-id="element-406">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-407">
                12. Governing law
              </h2>
              <p data-id="element-408">
                These Terms are governed by the laws of the State of California,
                without regard to conflict-of-law principles.
              </p>
            </section>

            <section data-id="element-409">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-410">
                13. Changes to the Terms
              </h2>
              <p data-id="element-411">
                We may update these Terms from time to time. Continued use of
                the Services after changes become effective constitutes
                acceptance of the updated Terms.
              </p>
            </section>

            <section data-id="element-412">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-413">
                14. Contact
              </h2>
              <p data-id="element-414">
                Questions about these Terms can be sent to:{' '}
                <a href="mailto:support@pulsewaveco.com" className="text-mint-500 hover:text-mint-400" data-id="element-415">
                  support@pulsewaveco.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>;
}